export const inputs = [
  { id: '60ede9a29f3f7f7c8c95987c', name: 'mainComplaint' },
  { id: '60ede9a29f3f7f7c8c95987d', name: 'medicalHistory' },
  { id: '60ede9a29f3f7f7c8c95987e', name: 'autoRefSphericalR' },
  { id: '60ede9a29f3f7f7c8c95987f', name: 'autoRefSphericalL' },
  { id: '60ede9a29f3f7f7c8c959880', name: 'autoRefCylindricalR' },
  { id: '60ede9a29f3f7f7c8c959881', name: 'autoRefCylindricalL' },
  { id: '60ede9a29f3f7f7c8c959882', name: 'autoRefAxisR' },
  { id: '60ede9a29f3f7f7c8c959883', name: 'autoRefAxisL' },
  { id: '685179e00257593386ea7e1e', name: 'autoRefNotes' },
  { id: '670fc53483f13d3960c191b7', name: 'autoRefLegacyR' },
  { id: '670fc54183f13d3960c191b8', name: 'autoRefLegacyL' },
  { id: '60ede9a29f3f7f7c8c959884', name: 'keratometryK1R' },
  { id: '60ede9a29f3f7f7c8c959885', name: 'keratometryK1L' },
  { id: '60ede9a29f3f7f7c8c959886', name: 'keratometryK2R' },
  { id: '60ede9a29f3f7f7c8c959887', name: 'keratometryK2L' },
  { id: '60ede9a29f3f7f7c8c959888', name: 'keratometryK1AxisR' },
  { id: '60ede9a29f3f7f7c8c959889', name: 'keratometryK1AxisL' },
  { id: '685179df0257593386ea7e1a', name: 'keratometryK2AxisR' },
  { id: '685179df0257593386ea7e1b', name: 'keratometryK2AxisL' },
  { id: '685179df0257593386ea7e1c', name: 'keratometryCylinderR' },
  { id: '685179e00257593386ea7e1d', name: 'keratometryCylinderL' },
  { id: '685179e00257593386ea7e1f', name: 'keratometryNotes' },
  { id: '670fc54883f13d3960c191b9', name: 'keratometryLegacyR' },
  { id: '670fc55083f13d3960c191ba', name: 'keratometryLegacyL' },
  { id: '60ede9a29f3f7f7c8c95988a', name: 'lensometrySphericalR' },
  { id: '60ede9a29f3f7f7c8c95988b', name: 'lensometrySphericalL' },
  { id: '60ede9a29f3f7f7c8c95988c', name: 'lensometryCylindricalR' },
  { id: '60ede9a29f3f7f7c8c95988d', name: 'lensometryCylindricalL' },
  { id: '60ede9a29f3f7f7c8c95988e', name: 'lensometryAxisR' },
  { id: '60ede9a29f3f7f7c8c95988f', name: 'lensometryAxisL' },
  { id: '60ede9a29f3f7f7c8d95988a', name: 'lensometryAddition' },
  { id: '60ede9a29f3f7f7d8c95988b', name: 'lensometryQuantity' },
  { id: '685179e00257593386ea7e20', name: 'lensometryNotes' },
  { id: '670fc55783f13d3960c191bb', name: 'lensometryLegacyR' },
  { id: '670fc55d83f13d3960c191bc', name: 'lensometryLegacyL' },
  { id: '60ede9a29f3f7f7c8c959890', name: 'autoTonometryR' },
  { id: '60ede9a29f3f7f7c8c959891', name: 'autoTonometryL' },
  { id: '60ede9a29f3f7f7c8c959892', name: 'autoTonometryTimeR' },
  { id: '60ede9a29f3f7f7c8c959893', name: 'autoTonometryTimeL' },
  { id: '670fc55d83f13d3960c191bd', name: 'autoTonometryLegacyR' },
  { id: '670fc55d83f13d3960c191be', name: 'autoTonometryLegacyL' },
  { id: '60ede9a29f3f7f7c8c959894', name: 'tonometryR' },
  { id: '60ede9a29f3f7f7c8c959895', name: 'tonometryL' },
  { id: '60ede9a29f3f7f7c8c959896', name: 'tonometryTimeR' },
  { id: '60ede9a29f3f7f7c8c959897', name: 'tonometryTimeL' },
  { id: '670fc55e83f13d3960c191c0', name: 'tonometryLegacyR' },
  { id: '670fc55e83f13d3960c191c1', name: 'tonometryLegacyL' },
  { id: '60ede9a29f3f7f7c8c959898', name: 'avscR' },
  { id: '60ede9a29f3f7f7c8c959899', name: 'avscL' },
  { id: '670fc55e83f13d3960c191c2', name: 'avscLegacyR' },
  { id: '670fc55f83f13d3960c191c3', name: 'avscLegacyL' },
  { id: '60ede9a29f3f7f7c8c95989a', name: 'avccR' },
  { id: '60ede9a29f3f7f7c8c95989b', name: 'avccL' },
  { id: '670fc55f83f13d3960c191c4', name: 'avccLegacyR' },
  { id: '670fc55f83f13d3960c191c5', name: 'avccLegacyL' },
  { id: '60ede9a29f3f7f7c8c95989c', name: 'refSubjSphericalR' },
  { id: '60ede9a29f3f7f7c8c95989d', name: 'refSubjSphericalL' },
  { id: '60ede9a29f3f7f7c8c95989e', name: 'refSubjCylindricalR' },
  { id: '60ede9a29f3f7f7c8c95989f', name: 'refSubjCylindricalL' },
  { id: '60ede9a29f3f7f7c8c9598a0', name: 'refSubjAxisR' },
  { id: '60ede9a29f3f7f7c8c9598a1', name: 'refSubjAxisL' },
  { id: '60ede9a29f3f7f7c8c9598a8', name: 'refSubjAvccR' },
  { id: '60ede9a29f3f7f7c8c9598a9', name: 'refSubjAvccL' },
  { id: '60ede9a29f3f7f7c8c9598aa', name: 'refSubjAddition' },
  { id: '60ede9a29f3f7f7c8a9598aa', name: 'refSubjQuantity' },
  { id: '67900f93d4a524bb47c191b7', name: 'refSubjNotes' },
  { id: '670fc56083f13d3960c191c6', name: 'refSubjLegacyR' },
  { id: '670fc56083f13d3960c191c7', name: 'refSubjLegacyL' },
  { id: '60ede9a29f3f7f7c8c9598a2', name: 'refObjSphericalR' },
  { id: '60ede9a29f3f7f7c8c9598a3', name: 'refObjSphericalL' },
  { id: '60ede9a29f3f7f7c8c9598a4', name: 'refObjCylindricalR' },
  { id: '60ede9a29f3f7f7c8c9598a5', name: 'refObjCylindricalL' },
  { id: '60ede9a29f3f7f7c8c9598a6', name: 'refObjAxisR' },
  { id: '60ede9a29f3f7f7c8c9598a7', name: 'refObjAxisL' },
  { id: '60ede9a29f3f7f7c8d9598a8', name: 'refObjAvccR' },
  { id: '60ede9a29f3f7f7c8d9598a9', name: 'refObjAvccL' },
  { id: '60ede9a29f3f7f7c8c9598ab', name: 'refObjAddition' },
  { id: '60ede9a29f3f7f7c8d9598ab', name: 'refObjQuantity' },
  { id: '67900f93d4a524bb47c191b8', name: 'refObjNotes' },
  { id: '670fc56183f13d3960c191c8', name: 'refObjLegacyR' },
  { id: '670fc56183f13d3960c191c9', name: 'refObjLegacyL' },
  { id: '60ede9a29f3f7f7c8c9598ac', name: 'biomicroscopyR' },
  { id: '60ede9a29f3f7f7c8c9598ad', name: 'biomicroscopyL' },
  { id: '60ede9a29f3f7f7c8c9598ae', name: 'fundusR' },
  { id: '60ede9a29f3f7f7c8c9598af', name: 'fundusL' },
  { id: '60ede9a29f3f7f7c8c9598b0', name: 'complementaryExams' },
  { id: '60ede9a29f3f7f7c8c9598b1', name: 'diagnosis' },
  { id: '60ede9a29f3f7f7c8c9598b2', name: 'conduct' },
  { id: '6789151fa14cb9420ac191b7', name: 'contactLensR' },
  { id: '6789151fa14cb9420ac191b8', name: 'contactLensL' },
  { id: '6789151fa14cb9420ac191b9', name: 'gonioscopyR' },
  { id: '6789151fa14cb9420ac191ba', name: 'gonioscopyL' },
  { id: '6789190ea14cb9420ac191c4', name: 'pupillaryDistance' },
  { id: '67dc0ef8fc272da002c191bc', name: 'observations' },
];

export const visualAcuityValues = [
  '20/15',
  '20/20',
  '20/25',
  '20/30',
  '20/40',
  '20/50',
  '20/60',
  '20/70',
  '20/80',
  '20/100',
  '20/125',
  '20/200',
  '20/250',
  '20/300',
  '20/400',
  '20/450',
  '20/600',
  '20/800',
  '20/1000',
  '20/1200',
  'CD a 1m',
  'CD a 1,5m',
  'CD a 2m',
  'CD a 3m',
  'Vultos',
  'PL',
  'PPL',
  'SPL',
  'SM',
];

export default inputs;
